const lastParagraph = document.querySelector(
  "article.content .channel:not(:has(~ .channel)) .left > p:last-of-type"
);
if (lastParagraph) {
  lastParagraph.insertAdjacentHTML("beforeend", '<span class="end-of-story-glyph"></span>');
  const glyph = lastParagraph.querySelector(".end-of-story-glyph");
  if (glyph) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          glyph.classList.add("show");
          observer.unobserve(glyph);
        }
      });
    });
    observer.observe(glyph);
  }
}
